// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner_wrapper__3tPFQ","leftImg":"banner_leftImg__3y0qK","rightImg":"banner_rightImg__11ARH","text":"banner_text__6qzmR","chip":"banner_chip__1Ymum"};